import React, { Component } from "react";
import { connect } from "react-redux";
import cx from "classnames";

import TitleComponent1 from "./PageTitleExamples/Variation1";
import TitleComponent2 from "./PageTitleExamples/Variation2";
import TitleComponent3 from "./PageTitleExamples/Variation3";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";

class PageTitle extends Component {
  randomize(myArray) {
    return myArray[Math.floor(Math.random() * myArray.length)];
  }

  render() {
    let {
      enablePageTitleIcon,
      enablePageTitleSubheading,
      style,
      heading,
      icon,
      subheading,
    } = this.props;

    var arr = [<TitleComponent1 />, <TitleComponent2 />, <TitleComponent3 />];

    return (
      <Row>
        <Col md="12">
          <div className="page-title-heading" style={{padding: "20px", ...style}}>
            {icon && (
              <div style={{ boxShadow: "none", display: "inline-block" }}>
                <i className={icon} />
              </div>
            )}
            <span> {heading}</span>
          </div>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  enablePageTitleIcon: state.ThemeOptions.enablePageTitleIcon,
  enablePageTitleSubheading: state.ThemeOptions.enablePageTitleSubheading,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PageTitle);
